define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/def",
	"csi/def/Field",
	"csi/table/NewFrom",
	"csi/wizard/ActionControllerMixin",
	"csi/xml",
	"./NewColorwayMixin"
], function(array,declare,lang,csi,_,def,Field,NewFrom,ActionControllerMixin,xml,NewColorwayMixin) {

	return declare([NewFrom, ActionControllerMixin, NewColorwayMixin], {
		getFormData: function() {
			// summary: add hook into form data to determine if node is already selected
			if (this.m_formData) return this.m_formData;

			var	fd = this.inherited(arguments);
			fd.m_bOmitSelections = true;
			fd.m_fAggregateSelected = lang.hitch(this, this._isCarriedOver, this._getMapOfCarriedOverColorways());
			return fd;
		},

		getWizardViewQuery: function(/*csi.wizard.Widget*/wizard, /*csi.view.Widget*/view, /*Number*/index) {
			// summary: add dependency path to view to get all colorways carried over from queried nodes
			view.relRoot.m_depPaths = ["Parent:CarriedOverFromColorways"];
			view.defView.bOwnCache = true;
			return null;
		},

		onNextPage: function(/*csi.wizard.Widget*/wizard,
							 /*csi.wizard.Content*/currentPage,
							 /*csi.wizard.Content*/nextPage,
							 /*Boolean*/bFinish) {
			// summary: prepare the data and pass it into the next page
			return bFinish ? null : this.inherited(arguments);
		},

		_getMapOfCarriedOverColorways: function() {
			// summary: returns the map of carried over Colorways
			var nodeStyle = this.getParent();
			var cache = this.getCache();
			var styleColorways = cache.getChildren(nodeStyle, "ProductColors", true);

			var mapCarriedOverColorways = {};
			_.forEach(styleColorways, function(nodeColorway){
				_.forEach(nodeColorway.CarriedOverFromColorways, function(urlCarriedOverFromColorway){
					mapCarriedOverColorways[urlCarriedOverFromColorway] = true;
				});
			}, this);
			return mapCarriedOverColorways;
		},

		_isCarriedOver: function(/*ObjectHash*/mapCarriedOverColorways, /*csi.def.Context*/ctx, /*csi.action.FormData*/fd) {
			// summary: determine if Colorway way carried over to the current Style already
			var urlColorway = ctx.getNodeURL();
			return mapCarriedOverColorways[urlColorway];
		},

		_getFormView: function(/*Node*/node, /*Boolean*/bCheckOnly) {
			// summary: add fields for adding to BOM and for carrying over SKUs
			var	defView = this.inherited(arguments);
			if (defView && !bCheckOnly) {
				this._addBomField(this.getParent(), defView);
				this._addCarryOverSKUsField(this.getParent(), defView);
			}

			return defView;
		},

		_addCarryOverSKUsField: function(/*Node*/style, /*def.View*/formView) {
			// summary: add checkbox field to form for carrying over SKUs
			formView.m_fields.push(lang.mixin(new Field(), {
				m_label: "ColorwayCarryOverSKUs",
				m_typeControl: def.FIELD_CHECKBOX,
				bPersist: true
			}));
		},

		_toWriterValidateNode: function() {
			// summary: call method to add to BOM(s) after all other operations
			this.inherited(arguments);
			this._writeBomField(this.getParentURL(), this.m_urlNode);
		},

		toWriterRequest: function(/*FormData?*/fd) {
			// summary: add SKU-carryover param to server op
			var call = this.inherited(arguments);
			var	b = this.m_formData.getFieldValue("ColorwayCarryOverSKUs");
			call.addParameter("CarryOverSKUs", xml.ATTR_BOOLEAN, b);
			return call;
		}
	});
});